import { getHttpClient } from 'src/http-client';

export async function getAzureFieldItem(args: {
  projectId: string;
  organizationName: string;
  workItemType: string;
  fieldName: string;
}) {
	try {
		const client = getHttpClient();
		const response = await client.get(`https://dev.azure.com/${args.organizationName}/${args.projectId}/_apis/wit/workitemtypes/${args.workItemType}/fields/${args.fieldName}?$expand=All&api-version=6.0`);
		if (response.status === 200) {
			return response.data;
		}

		return null;
	} catch (err) {
		throw new Error('Get azure field item error.');
	}
}